module.exports = __webpack_public_path__ + "img/receipt.7b04d78f.svg";